import { InputNumber as AntInputNumber } from 'antd';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { Height, InputFocus, InputStyle } from './input';
export const InputNumber = styled(AntInputNumber)`
  ${InputStyle};
  min-width: 90px;
  padding-right: var(--spacing-06);

  &.ant-input-number-disabled .ant-input-number-input {
    opacity: 0.5;
  }
  .ant-input-number-input {
    ${Height};
  }

  &.ant-input-number-focused {
    ${InputFocus};
  }

  .ant-input-number-handler-wrap {
    svg {
      width: var(--spacing-03);
      height: var(--spacing-03);
    }

    top: 2px;
    right: 2px;
    bottom: 2px;
    height: auto;
  }

  ${ifProp('ghost', css`
      border: none;
      background: var(--white-100);
    `)};

  html[data-new-theme-enabled='true'] & {
    background: var(--white-100) !important;
    border: 1px solid var(--gray-10) !important;
    border-radius: var(--border-radius-small) !important;
    border-bottom: 1px solid var(--gray-10) !important;
    padding-left: var(--spacing-03);
    &.ant-input-number-focused {
      outline: 1px solid var(--gray-20) !important;
    }
  }
`;
